import api from '@/security/api'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = () => {
    return api.get('/channels/all')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de todos os canais')
        })
}

const findAll = () => {
    return api.get('/channels')
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de canais')
        })
}

const findByService = (id) => {
    return api.get(`/channels/byservice/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os serviços do canal')
        })
}

const find = (id) => {
    return api.get(`/channels/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o canal')
        })
}

export default {
    all,
    findAll,
    findByService,
    find
}
